<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-02-23 17:45:27
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveReason\newLeaveReason.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveReason_form_newTitle')"
    widthClass="max-1000"
    :initData="LeaveReasonData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'leave_reason_name',
      'sequence',
      'leave_reason_description',
      'leave_reason_code',
      'leave_type_uuid',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="LeaveReasonData.leave_reason_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  LeaveReasonData.leave_reason_name = valueArr;
                }
              "
              :label="$t('label_essweb_leaveReason_form_leaveReasonNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveReason_form_leaveTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="leaveType"
              item-text="leave_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="$t('label_essweb_leaveReason_form_leaveTypeLabel')"
              v-model="LeaveReasonData.leave_type_uuid"
              filled
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              maxlength="10"
              type="number"
              :label="$t('label_essweb_leaveReason_form_sequenceLabel')"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
              "
              isNotRequire
              v-model="LeaveReasonData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="$t('label_essweb_leaveReason_form_codeLabel')"
              maxlength="50"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="LeaveReasonData.leave_reason_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="LeaveReasonData.leave_reason_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  LeaveReasonData.leave_reason_description = valueArr;
                }
              "
              :label="$t('label_essweb_leaveReason_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveReason_form_RemarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="LeaveReasonData.remarks"
              dense
              counter="500"
              single-line
              filled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newLeaveReason",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      leaveType: [],
      isChanged: false,
      LeaveReasonData: {
        leave_reason_name: "",
        sequence: 1,
        leave_reason_description: "",
        leave_reason_code: "",
        leave_type_uuid: "",
        remarks: "",
      },
    };
  },
  mounted() {
    // this.LeaveReasonData.leave_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.LeaveReasonData.leave_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getLeaveType();
  },
  methods: {
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.leave_type_name = that.$getCommonLangValue(item.leave_type_name);
        });
        that.leaveType = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/add/",
        data: {
          leave_reason_name: this.$transCommonLangKey(
            this.LeaveReasonData.leave_reason_name
          ),
          leave_reason_description: this.$transCommonLangKey(
            this.LeaveReasonData.leave_reason_description
          ),
          sequence: this.LeaveReasonData.sequence,
          leave_type_uuid: this.LeaveReasonData.leave_type_uuid,
          leave_reason_code: this.LeaveReasonData.leave_reason_code,
          remarks: this.LeaveReasonData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
